import { shouldShowUserConsentForm } from 'lib/users';
import { attributesConditionsMatch } from 'shared-helpers/customAttributes';

import type { RequestUser, ServerConfig } from 'shared-types';

const shouldShowUserCustomAttributesForm = (
  user: RequestUser,
  serverConfig: ServerConfig<'guest'>
) => {
  const { authSharedTwoFactor, userCustomAttributesForm } = serverConfig;

  // ensure user
  if (!user?.roles) return false;

  // check if form is enabled
  if (!userCustomAttributesForm?.isEnabled) return false;

  // check if user has accepted consent or terms if required
  if (shouldShowUserConsentForm(user, serverConfig)) return false;

  // check if form is only for self registered users
  // (and guests as guest users are always self registered)
  if (
    userCustomAttributesForm.onlySelfRegistered &&
    user.authenticatorType &&
    !user.isSelfRegistered &&
    !user.roles.includes('guest')
  ) {
    return false;
  }

  // check if local user requires two-factor authentication
  const userRequiresShared2FA =
    authSharedTwoFactor?.isEnabled &&
    authSharedTwoFactor?.isConfigured &&
    (!authSharedTwoFactor?.conditions?.length ||
      attributesConditionsMatch({
        conditions: authSharedTwoFactor?.conditions,
        customAttributeValues: user.customAttributes,
        omitCustomAttributes: false,
        user
      }));

  const userRequires2FA = userRequiresShared2FA || user.twoFactorAuthIsEnabled;

  if (userRequires2FA && user.authenticatorType === 'local') {
    return false;
  }

  return true;
};

export default shouldShowUserCustomAttributesForm;
